<template>
  <div class="a-textarea-wrapper" data-test-id="noteForDriverTxt">
    <v-textarea
      :clearable="clearable"
      class="a-textarea"
      :class="{ dark: dark }"
      :disabled="disabled"
      :label="label"
      :placeholder="placeholder"
      :type="type"
      :data-test-id="value"
      :rules="rules"
      :maxlength="maxLength"
      :rows="rows"
      :no-resize="noResize"
      :value="value"
      :counter="counter"
      @update:error="handleError"
      @input="handleChange"
    >
      <template v-slot:append>
        <div @click="handleClickIcon" class="clickable">
          <SvgIcon width="20" height="20" v-if="error" icon="Error" />
          <SvgIcon width="20" height="20" v-else-if="svgIcon && appendIcon" :icon="appendIcon" />
          <v-icon v-else-if="appendIcon" small color="grey">{{ appendIcon }}</v-icon>
        </div>
      </template>
    </v-textarea>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ATextArea',
  props: {
    // theme
    dark: {
      type: Boolean,
      default: false
    },
    value: {},
    // Icon name: [asset.icons/ material icon's name]
    appendIcon: {
      type: String
    },
    disabled: {
      type: Boolean
    },
    rows: {
      type: String
    },
    label: {
      type: String
    },
    placeholder: {
      type: String
    },
    // Use svgIcon library to inject file to inline html
    svgIcon: {
      type: Boolean
    },
    // Set input type
    type: {
      type: String,
      default: 'text'
    },
    // Array function to validate value
    rules: {
      type: Array,
      default: () => []
    },
    maxLength: {
      type: String
    },
    noResize: {
      type: Boolean,
      default: false
    },
    onError: {
      type: Function
    },
    onChange: {
      type: Function
    },
    onClickIcon: {
      type: Function
    },
    clearable: {
      type: Boolean,
      default: false
    },
    counter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      error: false
    }
  },
  methods: {
    handleError(value) {
      this.error = value
      this.$emit('onError', value)
    },
    handleChange(value) {
      this.$emit('input', value)
      this.$emit('onChange', value)
    },
    handleClickIcon() {
      this.$emit('onClickIcon')
    }
  }
}
</script>

<style lang="scss">
.a-textarea {
  // Disable style of vuetify
  &.v-input {
    padding: 0;
    margin: 0;
  }
  // End disable style of vuetify

  .v-input__slot {
    // Disable style of vuetify
    // remove border
    border: none !important;

    // remove border on hover
    &:hover,
    &:focus-within {
      border: none !important;
    }

    // remove border on focus
    &::before,
    &::after {
      display: none;
    }

    // Update custom style
    background-color: #fff;
    display: flex;
    padding: 6px 0 0;
    border-radius: 4px;
    margin-bottom: 6px;

    // Style for textarea
    .v-text-field__slot {
      .v-label {
        left: 12px !important;
        font-size: 16px !important;

        &.v-label--active {
          top: 14px !important;
          font-size: 14px !important;
        }
      }

      textarea {
        margin: 12px 0 12px 12px;
        padding: 0;
        padding-right: 8px;
        font-size: 14px;

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
          display: none;
          -webkit-appearance: none;
          margin: 0;
        }

        &[type='number'] {
          -moz-appearance: textfield; /* Firefox */
        }
      }
    }

    .v-input__append-inner {
      margin: 0;
      height: 100%;
      display: flex;
      align-self: flex-end !important;
      padding-left: 0;
      padding-right: 8px;
      padding-bottom: 10px;
    }
    //End update custom style
  }

  // Update custom style
  .clickable {
    cursor: pointer;
  }

  &.dark {
    .v-input__slot {
      background-color: #f2f2f2;
    }
  }

  .v-text-field__details {
    padding-left: 12px;
  }

  &.v-input--is-focused,
  &.v-input--is-dirty {
    .v-input__slot {
      align-items: flex-end;
    }
  }

  &.v-input--is-focused {
    .v-label {
      color: #ff8200 !important;

      &.error--text {
        color: #d44632 !important;
        caret-color: #d44632 !important;
      }
    }
  }

  &.error--text {
    color: #d44632 !important;
    caret-color: #d44632 !important;
  }
  //End update custom style
}
</style>
